import React from 'react';
import { useRecoilValue } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { ILabel } from '../../../../../../utils/types/contentful';
import { ProductPrice } from '../../../../../UI/Elements/Price/productPrice';
import { returnCurrencyCharFromCode } from '../../../../../../utils/globals';
import { withSuspense } from '../../../../../../utils/hocs/withSuspense';
import { Link } from '../../../../../UI/Elements/Link';
import { shopifyVariantsState } from '../../../../../../utils/recoil/product';
import { useMediaQuery } from '../../../../../../utils/hooks/useMediaQuery';
import { Breadcrumb } from '../../../../../UI/Navigation';

export interface ProductMainVariantDetailsHeaderProps {
  label: ILabel;
  shopifyVariant: any;
  id: string;
}

export const ProductMainVariantDetailsHeaderProductPrice = withSuspense(
  ({ category, shopifyVariants = [], size = '4xl' }) => {
    let shopifyVariant;

    if (shopifyVariants.length > 0) {
      shopifyVariant = shopifyVariants[0];
    } else {
      shopifyVariant = useRecoilValue(shopifyVariantsState)[0];
    }

    const price = shopifyVariant?.priceV2?.amount;
    const compareAtPrice = shopifyVariant?.compareAtPriceV2?.amount;
    const currency =
      shopifyVariant &&
      returnCurrencyCharFromCode(shopifyVariant.priceV2.currencyCode);

    return (
      <ProductPrice
        price={{ text: price }}
        compareAtPrice={compareAtPrice && { text: compareAtPrice }}
        currency={{ text: currency }}
        productCategory={category}
        size={size}
      />
    );
  },
  <div className='bg-gray-200 mb-4 rounded-full mr-2 animate-pulse w-12 h-7' />
);

const ProductMainCategoryBreadcrumb = ({ category, product }) => (
  <div className='flex items-center mb-2 mt-5 md:mt-6'>
    <Breadcrumb
      withJsonLd
      hideLast
      links={[
        { slug: { url: '' }, label: { text: 'Home' } },
        category,
        product,
      ]}
    />
  </div>
);

export const ProductMainVariantDetailsHeader: React.FC<
  ProductMainVariantDetailsHeaderProps
> = ({ label, subLabel, category, shopifyVariants }) => {
  const isWindowSmallSize = useMediaQuery('lg');

  return (
    <div className='w-full mt-2 mb-5'>
      <ProductMainCategoryBreadcrumb
        category={category}
        product={{ label }}
      />
      <div className='flex justify-between flex-wrap items-end'>
        <Label
          {...label}
          size={label?.size || '5xl'}
          color={{ classname: 'gray-900' }}
          truncate
        />
        {!isWindowSmallSize && (
          <ProductMainVariantDetailsHeaderProductPrice
            shopifyVariants={shopifyVariants}
            category={category}
          />
        )}
      </div>
      <div className='mt-2'>
        <Label
          {...subLabel}
          type='h1'
          weight='light'
          family='font-inter'
        />
      </div>
    </div>
  );
};
